import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import Popup from "reactjs-popup";

import PageSectionMenu from "./PageSectionMenu";
import { SectionTitle } from "./ClassicSectionCard";
import { toastError } from "../../../shared/toastHelper";
import { STATUS_OPTIONS, statusBadgeClass, pillLabel } from "../../RentalInvoice/statusLabels";

const offerMenuContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "135px",
  "padding": "0px",
  "zIndex": "1999"
}

const popupContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "250px",
  "padding": "0px"
};

const deleteModalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "500px",
  "padding": "15px"
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatCurrency = (value) => {
  if (!value && value !== 0) return '-';
  return formatter.format(value);
};

const ManagerentalInvoices = (props) => {
  const {
    csrfToken,
    team,
    confirm,
    currentUser,
    confirmPageSection,
    fetchPermissionSet,
    updateConfirmPageSection,
    showSectionMenu = true
  } = props;

  const [rentalInvoices, setrentalInvoices] = useState(props.rentalInvoices);

  const createInvoice = (e) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/rental_invoices`, {
      rental_invoice: {
        title: `${confirm.title} Rental Event`,
        type: "RentalInvoices::Base",
        calendar_event_id: confirm.id,
      }
    }).then(({ data }) => {
      window.location = `/teams/${team.id}/rental_invoices/${data.id}/edit`;
    }).catch((error) => {
      toastError(error.response?.data?.join(", ") || "Failed to create rental invoice");
    });
  };

  const updateRentalInvoiceStatus = (invoiceId, status) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.patch(`/teams/${team.id}/rental_invoices/${invoiceId}`, {
      rental_invoice: {
        status: status
      }
    }).then(() => {
      setrentalInvoices(rentalInvoices.map(invoice => invoice.id === invoiceId ? { ...invoice, status: status } : invoice));
    }).catch(() => {
      toastError("Failed to update rental invoice status");
    });
  };

  const deleteRentalInvoice = (invoiceId) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.delete(`/teams/${team.id}/rental_invoices/${invoiceId}`).then(() => {
      setrentalInvoices(rentalInvoices.filter(invoice => invoice.id !== invoiceId));
    }).catch(() => {
      toastError("Failed to delete rental invoice");
    });
  };

  return (
    <div>
      <div className="card-body">
        <div className="row pb-3">
          <div className="col">
            <SectionTitle title="Rental Invoices"
                          count={rentalInvoices.length}
                          locked={Boolean(confirmPageSection?.permission_set_id)} />
          </div>
          <div className="col-xs-auto" style={{"paddingRight": "15px"}}>
            {currentUser.can_manage_rental_invoices && rentalInvoices.length > 0 ? (
              <a href="#" onClick={createInvoice} className="btn btn-external btn-sm">
                <strong>New Rental Event</strong>
              </a>
            ) : null }
            {showSectionMenu ? (
              <PageSectionMenu csrfToken={csrfToken}
                               team={team}
                               confirm={confirm}
                               currentUser={currentUser}
                               confirmPageSection={confirmPageSection}
                               fetchPermissionSet={fetchPermissionSet}
                               updateConfirmPageSection={updateConfirmPageSection} />
            ) : null}
          </div>
        </div>
        {rentalInvoices.length > 0 ? (
          <div className="form-row">
            {rentalInvoices.sort((a, b) => {return new Date(a.created_at) - new Date(b.created_at)}).map((rentalInvoice, index) => (
              <div key={index} className="col-12 col-lg-6">
                <div className="card no-border mb-0 pb-2">
                  <div className="card-body rounded" style={{'background': "var(--od-c-f3f9fc, #f4f9fc)"}}>
                    <div className="row">
                      <div className="col">
                        <div className="text-muted small">INVOICE FOR</div>
                        <div className="d-flex flex-wrap" style={{"maxWidth": "70%"}}>
                          <div className="mr-2 strong text-overflow-ellipsis" title={rentalInvoice.client_name}>
                            {rentalInvoice.client_name || "---"}
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-auto" style={{ "position": "absolute", "right": "15px" }}>
                        {currentUser.can_manage_rental_invoices ? (
                          <Popup arrow={false}
                                 offsetY={5}
                                 position="bottom right"
                                 contentStyle={offerMenuContentStyle}
                                 onOpen={(e) => { e.preventDefault() }}
                                 trigger={open => (
                                   <span className={`badge ${statusBadgeClass(rentalInvoice.status)} clickable px-3 py-2`}>
                                     {pillLabel(rentalInvoice.status)}
                                     &nbsp;
                                     <i className="fas fa-caret-down"></i>
                                   </span>
                                 )}>
                            {close => (
                              <div className='row text-left'>
                                <div className="col-12">
                                  <ul className="list-group offer-inline-menu">
                                    {STATUS_OPTIONS.map(({ value, label }) => (
                                      <li key={value} className="list-group-item">
                                        <a href="#"
                                           onClick={(e) => {
                                             e.preventDefault();
                                             close();
                                             updateRentalInvoiceStatus(rentalInvoice.id, value);
                                           }}
                                           className="text-muted">
                                          <span className="text-dark">
                                            {label}
                                          </span>
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </Popup>
                        ) : (
                          <span className={`badge ${statusBadgeClass(rentalInvoice.status)} px-3 py-2`}>
                            {pillLabel(rentalInvoice.status)}
                          </span>
                        )}
                        {currentUser.can_manage_rental_invoices ? (
                          <Popup arrow={false}
                                 offsetY={5}
                                 position="bottom right"
                                 contentStyle={popupContentStyle}
                                 onOpen={(e) => { e.preventDefault() }}
                                 trigger={open => (
                                   <a href="#" className="pl-3">
                                     <i className="fas fa-ellipsis-v"></i>
                                   </a>
                                 )}>
                            {close => (
                              <div className='row text-left'>
                                <div className="col-12">
                                  <ul className="list-group offer-inline-menu">
                                    <li className="list-group-item">
                                      <a href={`/teams/${team.id}/rental_invoices/${rentalInvoice.id}/pdf`}
                                         target="_blank"
                                         className="text-muted">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-download"></i>
                                        </span>
                                        <span className="text-dark">
                                          Download PDF
                                        </span>
                                      </a>
                                    </li>
                                    <li className="list-group-item">
                                      <a href={`/teams/${team.id}/rental_invoices/${rentalInvoice.id}/edit`}
                                         className="text-muted">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-pencil"></i>
                                        </span>
                                        <span className="text-dark">
                                          Edit
                                        </span>
                                      </a>
                                    </li>
                                    <li className="list-group-item delete-invoice-li">
                                      <Popup
                                          trigger={
                                            <a href="#" className="text-danger">
                                              <span className="d-inline-block text-center" style={{width: "28px"}}>
                                                <i className="fas fa-trash"></i>
                                              </span>
                                              Delete
                                            </a>
                                          }
                                          modal
                                          contentStyle={deleteModalContentStyle}
                                          onOpen={(e) => { e.preventDefault() }}
                                          closeOnDocumentClick>
                                        {closeDeletePopup => (
                                          <div>
                                            <div className="row">
                                              <div className="col">
                                                <div className="row">
                                                  <div className="col">
                                                    <h5 style={{"marginBottom": "16px"}}>
                                                      <div className="strong">Delete rental event?</div>
                                                    </h5>
                                                  </div>
                                                  <div className="col-xs-auto">
                                                    <a href="#"
                                                       className="text-dark"
                                                       style={{"paddingRight": "15px"}}
                                                       onClick={(e) => {e.preventDefault(); closeDeletePopup();}}>
                                                      <i className="fa fa-times"></i>
                                                    </a>
                                                  </div>
                                                </div>
                                                <p>You're about to delete this rental event.</p>
                                                <p>This cannot be undone.</p>
                                                <p>Are you sure?</p>
                                                <div className="text-right">
                                                  <a href="#"
                                                     onClick={(e) => {
                                                       e.preventDefault();
                                                       closeDeletePopup();
                                                     }}>
                                                    Cancel
                                                  </a>
                                                  <a href="#"
                                                     className="btn btn-danger ml-3"
                                                     onClick={(e) => {
                                                       e.preventDefault();
                                                       closeDeletePopup();
                                                       close();
                                                       deleteRentalInvoice(rentalInvoice.id);
                                                     }}>
                                                    Yes, delete rental event
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </Popup>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </Popup>
                        ) : null}
                      </div>
                    </div>
                    <div className="row pt-3">
                      <div className="col-6">
                        <div className="text-muted small">CREATED ON</div>
                        <div>{rentalInvoice.human_created_at}</div>
                      </div>
                      <div className="col-6">
                        <div className="text-muted small">CREATED BY</div>
                        <div>{rentalInvoice.team_membership.name}</div>
                      </div>
                    </div>
                    <div className="row pt-3">
                      <div className="col-6">
                        <div className="text-muted small">TOTAL OWED</div>
                        <div>{formatCurrency(rentalInvoice.remaining_balance)}</div>
                      </div>
                      {Number(rentalInvoice.tax_fee_total) > 0 ? (
                        <div className="col-6">
                          <div className="text-muted small">TAXES &amp; FEES</div>
                          <div>{formatCurrency(rentalInvoice.tax_fee_total)}</div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {rentalInvoices.length === 0 ? (
          <div className="card no-border mb-0" style={{'background': 'var(--od-c-f3f9fc, #f4f9fc)'}}>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4 order-md-2 text-left text-md-center">
                  <i className="fal fa-file-signature" style={{"fontSize": "120px", "color": "rgba(25, 130, 196, .5)"}} />
                </div>
                <div className="col-12 col-md-6 col-lg-8 order-md-1">
                  <h5>Create a Rental Event</h5>
                  <p className="text-muted">
                    Build a rental event for this confirm.
                  </p>
                  {currentUser.can_manage_rental_invoices ? (
                    <a href="#" onClick={createInvoice} className="btn btn-primary">
                      <strong>Create Rental Event</strong>
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

ManagerentalInvoices.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirmPageSection: PropTypes.object,
  rentalInvoices: PropTypes.array.isRequired,
  fetchPermissionSet: PropTypes.func.isRequired,
  updateConfirmPageSection: PropTypes.func.isRequired,
  showSectionMenu: PropTypes.bool,
};

export default ManagerentalInvoices;
